/**
 * Default API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ChalengEuByMonthCounterViewModel } from '../model/chalengEuByMonthCounterViewModel';
// @ts-ignore
import { ChallengEUClientDeviceViewModel } from '../model/challengEUClientDeviceViewModel';
// @ts-ignore
import { KeyDateStatisticCounterViewModel } from '../model/keyDateStatisticCounterViewModel';
// @ts-ignore
import { QuizAgeRangeCounterViewModel } from '../model/quizAgeRangeCounterViewModel';
// @ts-ignore
import { QuizAverageCounterViewModel } from '../model/quizAverageCounterViewModel';
// @ts-ignore
import { QuizByMonthCounterViewModel } from '../model/quizByMonthCounterViewModel';
// @ts-ignore
import { QuizCountryCounterViewModel } from '../model/quizCountryCounterViewModel';
// @ts-ignore
import { QuizLanguageCounterViewModel } from '../model/quizLanguageCounterViewModel';
// @ts-ignore
import { QuizProfileCounterViewModel } from '../model/quizProfileCounterViewModel';
// @ts-ignore
import { QuizQuestionCounterViewModel } from '../model/quizQuestionCounterViewModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Returns the average time spent by game.
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsChallengeuAveragetimeGet(day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ChalengEuByMonthCounterViewModel>;
    public umbracoBackofficeApiStatisticsChallengeuAveragetimeGet(day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChalengEuByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuAveragetimeGet(day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChalengEuByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuAveragetimeGet(day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/challengeu/averagetime`;
        return this.httpClient.request<ChalengEuByMonthCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the devices used by the player.
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsChallengeuClientdevicesGet(day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ChallengEUClientDeviceViewModel>;
    public umbracoBackofficeApiStatisticsChallengeuClientdevicesGet(day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChallengEUClientDeviceViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuClientdevicesGet(day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChallengEUClientDeviceViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuClientdevicesGet(day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/challengeu/clientdevices`;
        return this.httpClient.request<ChallengEUClientDeviceViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the number of games by month during a dates range
     * @param day1 Date of start
     * @param day2 Date of end
     * @param completed Played games
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsChallengeuCountersGet(day1?: string, day2?: string, completed?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ChalengEuByMonthCounterViewModel>;
    public umbracoBackofficeApiStatisticsChallengeuCountersGet(day1?: string, day2?: string, completed?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChalengEuByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuCountersGet(day1?: string, day2?: string, completed?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChalengEuByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsChallengeuCountersGet(day1?: string, day2?: string, completed?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }
        if (completed !== undefined && completed !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>completed, 'completed');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/challengeu/counters`;
        return this.httpClient.request<ChalengEuByMonthCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the number of visitors at the console by month
     * @param id Umbraco KeyDateStoryId
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsKeydatesIdCountersGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<KeyDateStatisticCounterViewModel>;
    public umbracoBackofficeApiStatisticsKeydatesIdCountersGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KeyDateStatisticCounterViewModel>>;
    public umbracoBackofficeApiStatisticsKeydatesIdCountersGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KeyDateStatisticCounterViewModel>>;
    public umbracoBackofficeApiStatisticsKeydatesIdCountersGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsKeydatesIdCountersGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/keydates/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/counters`;
        return this.httpClient.request<KeyDateStatisticCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the Quiz counters by visitor age ranges (number of time a Quiz was taken)
     * @param id Umbraco Quiz ID
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdAgeRangesGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizAgeRangeCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdAgeRangesGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizAgeRangeCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdAgeRangesGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizAgeRangeCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdAgeRangesGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdAgeRangesGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/age-ranges`;
        return this.httpClient.request<QuizAgeRangeCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the Quiz counters by month(number of time a Quiz was taken)
     * @param id Umbraco Quiz ID
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdCountersByMonthGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizByMonthCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdCountersByMonthGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdCountersByMonthGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizByMonthCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdCountersByMonthGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdCountersByMonthGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/counters-by-month`;
        return this.httpClient.request<QuizByMonthCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the Quiz counters by visitor countries (number of time a Quiz was taken)
     * @param id Umbraco Quiz ID
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdCountriesGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizCountryCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdCountriesGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizCountryCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdCountriesGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizCountryCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdCountriesGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdCountriesGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/countries`;
        return this.httpClient.request<QuizCountryCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the Quiz counters by visitor language (number of time a Quiz was taken)
     * @param id Umbraco Quiz ID
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdLanguagesGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizLanguageCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdLanguagesGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizLanguageCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdLanguagesGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizLanguageCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdLanguagesGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdLanguagesGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/languages`;
        return this.httpClient.request<QuizLanguageCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the Quiz counters by visitor profile (number of time a Quiz was taken)
     * @param id Umbraco Quiz ID
     * @param day1 Date of start
     * @param day2 Date of end
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdProfilesGet(id: string, day1?: string, day2?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizProfileCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdProfilesGet(id: string, day1?: string, day2?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizProfileCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdProfilesGet(id: string, day1?: string, day2?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizProfileCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdProfilesGet(id: string, day1?: string, day2?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdProfilesGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (day1 !== undefined && day1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day1, 'day1');
        }
        if (day2 !== undefined && day2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>day2, 'day2');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/profiles`;
        return this.httpClient.request<QuizProfileCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the averages score for a specific Quiz
     * @param id Umbraco Quiz ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizIdScoreAveragesGet(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizAverageCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizIdScoreAveragesGet(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizAverageCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdScoreAveragesGet(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizAverageCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizIdScoreAveragesGet(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizIdScoreAveragesGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/score-averages`;
        return this.httpClient.request<QuizAverageCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the average score(%) of a question
     * @param id Umbraco question ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public umbracoBackofficeApiStatisticsQuizQuestionsIdScoresGet(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<QuizQuestionCounterViewModel>;
    public umbracoBackofficeApiStatisticsQuizQuestionsIdScoresGet(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<QuizQuestionCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizQuestionsIdScoresGet(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<QuizQuestionCounterViewModel>>;
    public umbracoBackofficeApiStatisticsQuizQuestionsIdScoresGet(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling umbracoBackofficeApiStatisticsQuizQuestionsIdScoresGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'text/plain'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/umbraco/backoffice/api/statistics/quiz/questions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/scores`;
        return this.httpClient.request<QuizQuestionCounterViewModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
